<template>
  <div class="pop-manage-edit">
    <section class="pop-edit-tool">
      <el-button
        class="tool-button tool-button-push"
        type="primary"
        :disabled="!saveStatus"
        :loading="loading"
        @click="publishPop"
      >
        {{ $t("couse.active") }}
      </el-button>
      <el-button class="tool-button" type="primary" :loading="loading" @click="savePop">
        {{ $t("save") }}
      </el-button>
      <el-button class="tool-button tool-button-info" type="info" @click="backList">
        {{ $t("course.return") }}
      </el-button>
    </section>
    <section class="pop-edit-info clearfix" v-if="isEdit != 1">
      <div class="edit-info-module edit-info-module1">
        <p class="info-module-name">{{ $t("pop.theme") }}:</p>
        <p class="info-module-value">{{ detailInfo.title }}</p>
      </div>
      <div class="edit-info-module">
        <p class="info-module-name">{{ $t("pop.creatorTitle") }}:</p>
        <p class="info-module-value">{{ detailInfo.creatByDesc }}</p>
      </div>
      <div class="edit-info-module">
        <p class="info-module-name">{{ $t("pop.createTime") }}:</p>
        <p class="info-module-value">{{ detailInfo.creatDate }}</p>
      </div>
      <div class="edit-info-module">
        <p class="info-module-name">{{ $t("pop.editorTitle") }}:</p>
        <p class="info-module-value">{{ detailInfo.chngByDesc }}</p>
      </div>
      <div class="edit-info-module">
        <p class="info-module-name">{{ $t("pop.chgTime") }}:</p>
        <p class="info-module-value">{{ detailInfo.chngDate }}</p>
      </div>
      <div class="edit-info-module">
        <p class="info-module-name">{{ $t("pop.status") }}:</p>
        <div :class="['info-status', 'info-status' + detailInfo.status]">
          {{ detailInfo.statusDesc }}
        </div>
      </div>
    </section>
    <section class="pop-edit-contain">
      <div class="pop-edit-form clearfix">
        <el-form
          label-position="left"
          label-width="100px"
          ref="editForm"
          :model="popData"
          :rules="editRule"
        >
          <el-form-item :label="$t('pop.themeTitle')" class="form-li" prop="title">
            <el-input
              v-model="popData.title"
              :placeholder="$t('pop.themePlaceHolder')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('pop.popType')" class="form-li" prop="type">
            <el-radio-group v-model="popData.type">
              <el-radio
                v-for="(item, index) in typeList"
                :label="item.key"
                :key="'type' + item.key"
                @change="changeType"
                >{{ item.value }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
          <!-- 上传封面 -->
          <el-form-item
            :label="$t('pop.uploadCover')"
            class="form-li clearfix"
            prop="picUrl"
          >
            <el-upload
              ref="coverUpload"
              :action="imgAction"
              list-type="picture-card"
              accept=".jpg,.jpeg,.png,.gif"
              :show-file-list="false"
              :auto-upload="false"
              class="pop-cover-upload"
              :on-change="changeCover"
              :http-request="httpRequestCover"
              :before-upload="beforeAvatarUpload"
              v-show="!picShow"
            >
              <div class="pop-cover-img"></div>
            </el-upload>
            <div class="pop-cover-upload upload2" v-show="picShow">
              <img alt="" :src="popData.picUrl" alt="popDataImg"/>
              <span class="pop-cover-upload-close el-icon-close" @click="delCover"></span>
            </div>
            <p class="pop-cover-info" v-if="!picShow">
              {{ $t("pop.imgInfo") }}
            </p>
          </el-form-item>
          <!-- 面向群组 所有都有-->
          <el-form-item :label="$t('pop.group')" class="form-li" prop="csList">
            <el-button class="tool-button" type="primary" @click="showGroup">
              {{ $t("pop.chose") }}
            </el-button>
            <div class="group-content clearfix">
              <div
                class="group-card"
                v-for="(item, index) in popData.csList"
                :key="'group' + index"
              >
                {{ item.bizDesc }}
                <span class="group-card-close" @click="delGroup(index)"></span>
              </div>
            </div>
          </el-form-item>
          <!-- 关联链接 -->
          <el-form-item
            :label="$t('pop.connetSelect')"
            class="form-li clearfix"
            v-if="
              popData.type !== 80 &&
              popData.type !== 2 &&
              popData.type !== 3 &&
              popData.type !== 24 &&
              popData.type !== 28
            "
            prop="relatedDesc"
          >
            <div style="display: flex; flex-direction: column; align-items: flex-start;">
              <el-button class="tool-button" type="primary" @click="showConnect">
                {{ $t("pop.chose") }}
              </el-button>
              <div class="pop-edit-connect" style="display: flex;margin: 10px 0;">
                <div>{{ popData.relatedDesc }}</div>
                <div
                        class="el-icon-close connect-close"
                        v-if="popData.relatedDesc"
                        @click="delRelative"
                ></div>
              </div>
            </div>
          </el-form-item>
          <!-- 网页链接 -->
          <el-form-item
            :label="$t('pop.link')"
            class="form-li"
            v-if="popData.type === 2 || popData.type === 3"
            prop="content"
          >
            <el-input
              v-model="popData.content"
              :placeholder="$t('pop.linkPlaceHolder')"
            ></el-input>
          </el-form-item>
          <!-- 文件上传 -->
          <el-form-item
            :label="$t('pop.fileUpload')"
            class="form-li"
            v-if="popData.type === 24"
            prop="fileResource"
          >
            <el-upload
              ref="fileUpload"
              :action="fileAction"
              class="pop-fileupload"
              :auto-upload="false"
              :show-file-list="false"
              :http-request="httpRequest"
              :on-change="changeFile"
              accept=".jpg,.gif,.png,.jpeg,.zip"
            >
              <el-button class="tool-button" type="primary">
                {{ $t("pop.chose") }}
              </el-button>
            </el-upload>
            <div class="pop-edit-connect">
              {{ popData.fileName }}
              <span
                class="el-icon-close connect-close"
                v-if="popData.fileName"
                @click="delFileName"
              ></span>
            </div>
          </el-form-item>
          <!-- 生效时间 -->
          <el-form-item :label="$t('pop.validTime')" class="form-li">
            <el-date-picker
              v-model="effectiveTime"
              style="width: 100%"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm"
              format="yyyy-MM-dd HH:mm"
              :start-placeholder="$t('organization.startData')"
              :end-placeholder="$t('organization.endData')"
            >
            </el-date-picker>
          </el-form-item>
          <!-- 图文内容 -->
          <el-form-item
            :label="$t('pop.imgContent')"
            class="form-li"
            v-if="popData.type === 80"
            prop="graphicsContext"
          >
            <div v-for="(item, index) in imgList" :key="'imgtitle' + index">
              <div class="pop-imgcontent-module" v-if="item.type === 1">
                <el-input
                  v-model="item.value"
                  type="textarea"
                  maxlength="500"
                  rows="6"
                  resize="none"
                  show-word-limit
                  :placeholder="$t('pop.imginfoPlaceHolder')"
                ></el-input>
                <span
                  class="el-icon-remove module-icon"
                  @click="delImgInfo(index)"
                ></span>
              </div>
              <div class="pop-imgcontent-module clearfix" v-if="item.type === 2">
                <el-upload
                  action=""
                  :show-file-list="false"
                  class="pop-imgcontent-upload"
                  v-if="!item.value"
                  :before-upload="beforeAvatarUpload"
                  :auto-upload="false"
                  ref="uploadFile"
                  :http-request="
                    (res) => {
                      return httpRequest2(res, index);
                    }
                  "
                  :on-change="
                    (res, file) => {
                      return changeFile2(res, file, index);
                    }
                  "
                >
                  <div class="pop-cover-img pop-cover-img2"></div>
                </el-upload>
                <div class="pop-imgcontent-upload pop-imgcontent-upload2" v-else>
                  <img alt="" :src="item.value" alt="imgContent"/>
                </div>
                <span
                  class="el-icon-remove module-icon module-icon2"
                  @click="delImg(index)"
                ></span>
                <p class="pop-cover-info pop-cover-info2" v-if="!item.value">
                  {{ $t("pop.imgInfo2") }}
                </p>
              </div>
            </div>
            <p class="pop-imgcontent-line"></p>
            <div class="pop-imgcontent-button">
              <span class="pop-imgcontent-add" @click="addImgTitle">
                <em class="el-icon-circle-plus"></em>{{ $t("pop.addText") }}</span
              >
              <span class="pop-imgcontent-add" @click="addImgSrc">
                <em class="el-icon-circle-plus"></em>{{ $t("pop.addImg") }}</span
              >
            </div>
          </el-form-item>
        </el-form>
      </div>
    </section>
    <!-- 群组选择弹框 -->
    <GroupModal
      :dialogShow="groupDialogShow"
      @closeHandle="closeGroup"
      @saveGroup="saveGroup"
      v-if="groupDialogShow"
      :groupChose="popData.csList"
    ></GroupModal>
    <ConnectModal
      :dialogShow="connectDialogShow"
      :popType="popData.type"
      v-if="connectDialogShow"
      @closeHandle="closeRelative"
      @backType="backType"
      @saveRelative="saveRelative"
    ></ConnectModal>
    <ModuleModal
      :dialogShow="moduleDialogShow"
      v-if="moduleDialogShow"
      @closeHandle="closeModule"
    ></ModuleModal>
  </div>
</template>
<script>
import GroupModal from "./groupModal";
import ConnectModal from "./relativeModal";
import ModuleModal from "./moduleModal";

export default {
  components: {
    GroupModal,
    ConnectModal,
    ModuleModal,
  },
  data() {
    return {
      loading: false,
      disabled: true,
      effectiveTime: [],
      content: "",
      detailInfo: {},
      textarea: "",
      groupDialogShow: false,
      connectDialogShow: false,
      moduleDialogShow: false,
      popData: {
        theme: "",
        type: "",
        fileName: "",
        graphicsContext: [],
        csList: [],
      },
      imgSrc: "",
      typeList: [],
      imgAction: `${window.SITE_CONFIG["apiUploadURL"]}` + "/slider/fileUpload",
      fileAction: "",
      editRule: {
        title: [
          { required: true, message: this.$t("pop.themePlaceHolder"), trigger: "blur" },
        ],
        type: [
          { required: true, message: this.$t("pop.typePlaceHolder"), trigger: "change" },
        ],
        picUrl: [
          { required: true, message: this.$t("pop.uploadCoverInfo"), trigger: "blur" },
        ],
        csList: [
          { required: true, message: this.$t("pop.groupPlaceHolder"), trigger: "change" },
        ],
        relatedDesc: [
          { required: true, message: this.$t("pop.linkPlaceHolder"), trigger: "blur" },
        ],
        content: [
          { required: true, message: this.$t("pop.weblinkPlaceHolder"), trigger: "blur" },
        ],
        fileResource: [
          { required: true, message: this.$t("pop.fileInput"), trigger: "blur" },
        ],
        graphicsContext: [
          { required: true, trigger: "blur", message: this.$t("pop.imgIput") },
        ],
      },
      imgList: [{ value: "", type: 1 }],
      recommendId: "",
      fileResource: "",
      saveStatus: false,
      picShow: false,
    };
  },
  computed: {
    isEdit() {
      return this.$route.query.edit;
    },
    graphicsContext() {
      return this.imgList.filter((item) => {
        return item.value;
      });
    },
  },
  watch: {
    graphicsContext: {
      handler() {
        if (this.graphicsContext.length > 0) {
          this.popData.graphicsContext = this.graphicsContext;
          this.$refs.editForm.clearValidate("graphicsContext");
        } else {
          this.$refs.editForm.validateField("graphicsContext");
        }
      },
      deep: true,
    },
  },
  methods: {
    // 返回列表页面
    backList() {
      this.tabRemove();
      this.$router.push({
        name: "sys-communicationPop-popManage",
      });
      this.recommendId = "";
      this.$eventHub.$emit("popManageList", "");
    },
    formDateTime(val) {
      let date = new Date(val * 1);
      let year = date.getFullYear();
      let month = date.getMonth() < 9 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
      let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      let hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      let minute = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return `${year}-${month}-${day} ${hour}:${minute}:${seconds}`;
    },
    // 获取初始化数据
    getDetail() {
      let params = {
        recommendId: this.$route.query.recommendId,
      };
      this.imgList = [];
      this.imgtitlelist = [];
      this.disabled = false;
      this.picShow = true;
      this.$request.post("/sys/popsUpMsg/initEdit", params).then((res) => {
        if (res) {
          let data = res.recommendVO;
          this.typeList = res.recommendTypes || [];
          if (data.graphicsContext) {
            let arr = JSON.parse(data.graphicsContext) || [];
            this.imgList = arr;
          }
          if (data.creatDate.indexOf("-") === -1) {
            data.creatDate = this.formDateTime(data.creatDate);
          }
          if (data.chngDate.indexOf("-") === -1) {
            data.chngDate = this.formDateTime(data.chngDate);
          }
          this.detailInfo = data;
          this.popData = JSON.parse(JSON.stringify(data));
          if (data.effectiveEndTimeString) {
            this.effectiveTime = [
              data.effectiveStartTimeString,
              data.effectiveEndTimeString,
            ];
          } else {
            this.effectiveTime = [];
          }
          this.recommendId = data.recommendId;
        }
      });
    },
    //  新增获取类型
    getDic() {
      this.$request.post("/sys/popsUpMsg/initCreate").then((res) => {
        if (res) {
          this.typeList = res.recommendTypes || [];
          this.popData.type = 5;
        }
      });
    },
    // pop类型修改
    changeType(val) {
      this.popData.type = val;
      this.$refs.editForm.clearValidate();
      if (this.popData.type === 80) {
        this.imgtitlelist = [{ value: "", type: 1 }];
      }
      if (this.popData.type === 28) {
        this.moduleDialogShow = true;
      }
      this.$set(this.popData, "relatedDesc", '');
      this.$set(this.popData, "relatedId", '');
      this.$set(this.popData, "relatedIdStr", '');
    },
    // 关闭组群更新接口
    closeGroup() {
      this.groupDialogShow = false;
    },
    // 关闭类型模板接口
    closeModule(val) {
      this.moduleDialogShow = false;
      if (!val) {
        this.$set(this.popData, "type", 5);
      }
      if (val.imgUrl) {
        this.picShow = true;
        this.$set(this.popData, "picUrl", val.imgUrl);
      }
    },
    // 关闭关联弹窗
    closeRelative() {
      this.connectDialogShow = false;
    },
    // 选择群组的弹框展示
    showGroup() {
      this.groupDialogShow = true;
    },
    // 选择关联链接弹框展示
    showConnect() {
      this.connectDialogShow = true;
    },
    // 保存按钮
    savePop() {
      this.$refs["editForm"].validate((valid) => {
        if (this.popData.picUrl) {
          this.$refs.editForm.clearValidate("picUrl");
        }
        if (this.popData.csList.length > 0) {
          this.$refs.editForm.clearValidate("csList");
        }
        if (this.popData.relatedDesc) {
          this.$refs.editForm.clearValidate("relatedDesc");
        }
        if (this.effectiveTime && this.effectiveTime.length === 2) {
          if (new Date(this.effectiveTime[1]).getTime() < Date.now()) {
            this.$message({
              message: this.$t("pop.endTimeInfo"),
              type: "warning",
            });
            return false;
          }
        } else {
          this.effectiveTime = []
        }
        if (valid) {
          this.loading = true;
          let groupId = [];
          if (this.popData.csList && this.popData.csList.length > 0) {
            groupId = this.popData.csList.map((item) => {
              return item.bizId;
            });
          }
          let params = {
            popUps: 1,
            title: this.popData.title,
            type: this.popData.type,
            groupIds: JSON.stringify(groupId),
            picUrl: this.popData.picUrl,
            effectiveStartTimeString: this.effectiveTime[0]
              ? this.effectiveTime[0] + ":00"
              : "1970-01-01 08:00:00",
            effectiveEndTimeString: this.effectiveTime[1]
              ? this.effectiveTime[1] + ":00"
              : "1970-01-01 08:00:00",
            currentUserCode: JSON.parse(sessionStorage.getItem("v1user_data")).userCode,
          };
          if (this.recommendId) {
            params.recommendId = this.recommendId;
          }
          switch (this.popData.type) {
            case 5:
              params.relatedId = this.popData.relatedId || "";
              break;
            case 30:
              params.relatedId = this.popData.relatedId || "";
              break;
            case 12:
              params.relatedId = this.popData.relatedId || "";
              break;
            case 9:
              params.relatedId = this.popData.relatedId || "";
              break;
            case 80:
              params.graphicsContext = JSON.stringify(this.graphicsContext);
              break;
            case 2:
              params.url = this.popData.content || "";
              break;
            case 3:
              params.url = this.popData.content || "";
              break;
            case 24:
              params.fileResource = this.popData.fileResource || "";
              break;
            case 65:
              params.relatedId = this.popData.relatedId || "";
              break;
            case 36:
              params.relatedId = this.popData.relatedId || "";
              params.relatedIdStr = this.popData.relatedIdStr || "";
              break;
            default:
              break;
          }
          if (params.fileResource) {
            params.url = params.fileResource
            params.fileResource = ''
          }
          this.$request.post("/sys/popsUpMsg/save", params).then((res) => {
            if (res) {
              if (res.status === "success") {
                this.loading = false;
                this.$message({
                  message: "保存成功",
                  type: "success",
                });
                if (res.id) {
                  this.recommendId = res.id;
                }
                this.saveStatus = true;
              } else {
                this.loading = false;
                this.$message({
                  message: res.message,
                  type: "warning",
                });
              }
            }
          }).catch(() => {
            this.loading = false;
          });
        } else {
          return false;
        }
      });
    },
    // 删除封面
    delCover(file) {
      this.$set(this.popData, "picUrl", "");
      if (this.popData.type === 28) {
        this.$set(this.popData, "type", 5);
      }
      this.picShow = false;
      this.$refs.coverUpload.clearFiles();
    },
    // 发布
    publishPop() {
      this.loading = true;
      let params = {
        recommendId: this.recommendId,
        currentUserCode: JSON.parse(sessionStorage.getItem("v1user_data")).userCode,
      };
      this.$request.post("/sys/popsUpMsg/updateStatus", params).then((res, total, code, data) => {
        if (res) {
          if (res.status === "success") {
            this.loading = false;
            this.$message({
              message: data.data.message === 'success' ? "发布成功" :data.data.message,
              type: "success",
            });
            this.backList();
          } else {
            this.loading = false;
            this.$message({
              message: res.message,
              type: "warning",
            });
          }
        }
      }).catch(() => {
            this.loading = false;
      });
    },
    // 图片校验
    beforeAvatarUpload(file) {
      const isJPG =
        file.type === "image/gif" ||
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg";
      const isLt4M = file.size / 1024 / 1024 < 4;
      if (!isLt4M) {
        this.$message.error("上传图片大小不能超过 4MB!");
      }
      return isJPG && isLt4M;
    },
    // 封面上传
    changeCover(file) {
      if (file) {
        this.picShow = false;
        this.$refs.coverUpload.submit();
      } else {
        this.$refs.editForm.validateField("picUrl");
      }
    },
    httpRequestCover(params) {
      let formData = new FormData();
      formData.append("file", params.file);
      this.$request
        .post(
          `/file/uploadFile?fileName=${encodeURIComponent(params.file.name)}&containerName=resource&type=3`,
          formData
        )
        .then((res) => {
          if (res) {
            this.picShow = true;
            this.$set(this.popData, "picUrl", res);
          }
        }).catch((err) => {
          this.picShow = false;
          this.$refs.coverUpload.clearFiles();
        })
    },
    // 文件
    changeFile(file) {
      if (file) {
        this.$refs.fileUpload.submit();
      } else {
        this.$refs.editForm.validateField("fileResource");
      }
    },
    delFileName() {
      this.popData.fileResource = "";
      this.popData.fileName = "";
      this.$refs.fileUpload.clearFiles();
      this.$refs.editForm.validateField("fileResource");
    },
    httpRequest(params) {
      let formData = new FormData();
      formData.append("file", params.file);
      let type = 3
      if (this.popData.type === 24 && params.file.name.indexOf('.zip') >=0) {
        type = 4
      }
      this.$request
        .post(
          `/file/uploadFile?fileName=${params.file.name}&containerName=resource&type=${type}`,
          formData
        )
        .then((res) => {
          this.$set(this.popData, "fileResource", res);
          this.$set(this.popData, "fileName", params.file.name);
        })
    },
    // 图文图片上传
    changeFile2(file, fileList, index) {
      if (file) {
        this.$refs.uploadFile[0].submit();
      }
    },
    httpRequest2(params, index) {
      let formData = new FormData();
      formData.append("file", params.file);
      this.$request
        .post(
          `/file/uploadFile?fileName=${params.file.name}&containerName=resource&type=3`,
          formData
        )
        .then((res) => {
          this.imgList[index].value = res;
        })
    },
    // 增加图文
    addImgTitle() {
      this.imgList.push({ value: "", type: 1 });
    },
    addImgSrc() {
      this.imgList.push({ value: "", type: 2 });
    },
    saveGroup(val) {
      let arr = val.map((item) => {
        return { bizId: item.groupId, bizDesc: item.groupName };
      });
      this.$set(this.popData, "csList", arr);
    },
    // 删除群组
    delGroup(index) {
      this.popData.csList.splice(index, 1);
    },
    // 反向联动
    backType(val) {
      switch (val) {
        case 1:
          this.popData.type = 5;
          break;
        case 2:
          this.popData.type = 9;
          break;
        case 4:
          this.popData.type = 12;
          break;
        case 5:
          this.popData.type = 30;
          break;
        case 6:
          this.popData.type = 65;
          break;
        case 7:
          this.popData.type = 36;
          break;
        default:
          break;
      }
    },
    saveRelative(val) {
      console.log('val============',val)
      this.connectDialogShow = false;
      this.$set(this.popData, "relatedDesc", val[0].courseName || val[0].title);
      this.popData.relatedId = val[0].courseId || val[0].broadcastId || val[0].documentId;
      this.popData.relatedIdStr = val[0].type+':'+val[0].id;
    },
    // 删除并校验关联选择
    delRelative() {
      this.$set(this.popData, "relatedDesc", "");
    },
    // 删除图文时候的图片描述or图片
    delImgInfo(index) {
      this.imgList.splice(index, 1);
    },
    delImg(index) {
      this.imgList.splice(index, 1);
    },
    // 删除当前页面
    tabRemove() {
      let tabName = this.$store.state.contentTabsActiveName;
      if (tabName === "home") {
        return false;
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(
        (item) => item.name !== tabName
      );
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName =
          "home";
        return false;
      }
      // 当前选中tab被删除
      if (tabName === this.$store.state.contentTabsActiveName) {
        this.$router.push({
          name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1]
            .name,
        });
      }
    },
  },
  mounted() {
    if (this.$route.query.edit == 1) {
      this.getDic();
    } else {
      this.saveStatus = true;
      this.getDetail();
    }
    this.$eventHub.$on("popManageEdit", () => {
      this.saveStatus = false;
      if (this.$route.query.edit == 1) {
        this.popData = {
          type: 5,
          theme: "",
          fileName: "",
          picUrl: "",
          content: "",
          relatedDesc: "",
          graphicsContext: [],
          fileResource: "",
          csList: [],
        };
        this.picShow = false;
        this.effectiveTime = [];
        this.imgtitlelist = [];
        this.imglist = [{ value: "", type: 1 }];
        this.getDic();
      } else {
        this.popData = {};
        this.saveStatus = true;
        this.getDetail();
      }
    });
  },
  beforeDestroy() {
    this.recommendId = "";
  },
};
</script>
<style lang="scss" scoped>
.pop-manage-edit {
  height: 100%;
  .pop-edit-tool {
    text-align: right;
    background-color: #ffffff;
    padding: 12px;
    margin-bottom: 12px;
    .tool-button {
      widows: 80px;
      display: inline-block;
      &.tool-button-push {
        background: rgb(102, 197, 177) !important;
        border: 1px solid rgb(102, 197, 177) !important;
        &:hover {
          opacity: 0.8;
          background: rgb(102, 197, 177) !important;
        }
      }
    }
  }
  .pop-edit-info {
    background-color: #ffffff;
    height: 84px;
    padding: 18px 30px;
    margin-bottom: 12px;
    .edit-info-module {
      width: 16%;
      height: 100%;
      float: left;
      position: relative;
      padding-right: 20px;
      &.edit-info-module1 {
        width: 20%;
      }
      &::after {
        content: "";
        position: absolute;
        top: 0;
        right: 20px;
        height: 100%;
        width: 1px;
        background-color: #dcdfe6;
      }
      &:last-child::after {
        display: none;
      }
      p {
        margin: 0;
        height: 22px;
        line-height: 22px;
      }
      .info-module-name {
        margin-bottom: 2px;
      }
      .info-module-value {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .info-status {
        height: 22px;
        line-height: 22px;
        text-align: center;
        width: 100px;
        color: #ffffff;
        &.info-status0 {
          background-color: #fe7aa2;
        }
        &.info-status1 {
          background-color: #65b0f3;
        }
        &.info-status9 {
          background-color: #2c3d51;
        }
      }
    }
  }
  .pop-edit-contain {
    background-color: #ffffff;
    padding: 28px 20px 12px 20px;
    .pop-edit-form {
      width: 62%;
      min-width: 860px;
      .el-form-item {
        width: 90% !important;
      }
      .form-li {
        .el-form-item__label {
          line-height: 32px !important;
        }
        .el-radio {
          margin-bottom: 12px;
          font-weight: normal;
        }
        margin-bottom: 32px !important;
        .pop-cover-upload {
          width: 158px;
          height: 206px;
          float: left;
          position: relative;
          .pop-cover-upload-close {
            position: absolute;
            right: 2px;
            top: 2px;
            color: #000000;
            cursor: pointer;
            z-index: 50;
            font-size: 14px;
          }
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
          &.upload2 {
            border: 1px dashed #c0ccda;
          }
          .el-upload--picture-card {
            height: 100% !important;
            width: 100% !important;
          }
        }
        .pop-fileupload {
          display: inline-block;
        }
        .pop-cover-img {
          height: 100%;
          background: url("~@/assets/img/add-img.png") no-repeat center center/45% 40%;
          &.pop-cover-img2 {
            background: url("~@/assets/img/add-img.png") no-repeat center center/20% 60%;
          }
        }
        .pop-cover-info {
          float: left;
          line-height: 180px;
          margin-left: 25px;
          color: #626262;
          font-size: 13px;
          &.pop-cover-info2 {
            line-height: 80px;
          }
        }
        .group-content {
          line-height: 32px;
          min-height: 32px;
          height: auto;
          border: 1px solid #dcdfe6;
          border-radius: 5px;
          padding: 8px 0 0 8px;
          display: flex;
          flex-wrap: wrap;
          margin-top: 12px;
          .group-card {
            background-color: #3278b4;
            font-size: 12px;
            height: 32px;
            margin: 0 8px 8px 0;
            padding: 0 20px 0 9px;
            color: #ffffff;
            border-radius: 4px;
            cursor: pointer;
            font-weight: normal;
            position: relative;
            .group-card-close {
              position: absolute;
              width: 12px;
              height: 12px;
              right: 3px;
              top: 10px;
              &:hover {
                opacity: 0.8;
              }
              background: url("~@/assets/img/close_noborder.png") no-repeat center
                center/100% 100%;
            }
          }
        }
        .pop-edit-connect {
          display: inline-block;
          margin-left: 20px;
          color: #626262;
          font-size: 14px;
          line-height: 14px;
          .connect-close {
            cursor: pointer;
            color: #4081b9;
            font-size: 14px;
          }
        }
        .pop-imgcontent-line {
          border-bottom: 1px dashed #d9d9d9;
          margin-bottom: 10px;
        }
        .pop-imgcontent-button {
          .pop-imgcontent-add {
            margin-right: 20px;
            cursor: pointer;
            &:hover {
              opacity: 0.9;
            }
            i {
              margin-right: 5px;
              color: #8de46a;
              font-size: 14px;
            }
          }
        }
        .pop-imgcontent-module {
          position: relative;
          margin-bottom: 20px;
          .module-icon {
            position: absolute;
            right: -20px;
            top: 2px;
            color: #ff3636;
            cursor: pointer;
            &:hover {
              opacity: 0.9;
            }
            &.module-icon2 {
              left: 305px;
              right: 0;
            }
          }
          .pop-imgcontent-upload {
            width: 300px;
            height: 118px;
            float: left;
            .pop-cover-img {
              width: 100%;
              height: 100%;
            }
            &.pop-imgcontent-upload2 {
              border: 1px dashed #c0ccda;
            }
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.pop-cover-upload {
  .el-upload {
    height: 100% !important;
    width: 100% !important;
  }
}
.pop-imgcontent-upload {
  .el-upload {
    height: 100% !important;
    width: 100% !important;
    position: relative;
    border: 1px dashed #c0ccda !important;
  }
}
</style>
